export default "__VITE_ASSET__B__6rZlh__"